var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-card",class:{
    startAfternoon: _vm.leavePeriod.startsAfternoon,
  },style:({
    width: _vm.leavePeriod.duration * _vm.columnWidth + _vm.unityColumnWidth,
  }),attrs:{"id":_vm.leavePeriod.details.id},on:{"mouseup":function($event){return _vm.showEvent($event, _vm.leavePeriod)}}},[_c('div',{staticClass:"iconsOptions"},[(_vm.leavePeriod.details.comments)?_c('div',{staticClass:"redDot mt-1",attrs:{"title":_vm.leavePeriod.details.comments}}):_vm._e()]),_c('p',{style:({ background: _vm.leavePeriod.color })},[_vm._v("\n    "+_vm._s(_vm.$enumLeavePeriodType.find((l) => l.value === _vm.leavePeriod.details.type)
        .text)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }